import {
  BLUE_GRAY_100,
  BLUE_GRAY_50,
  GREEN_100,
  GREEN_50,
  RED_100,
  RED_50,
} from './Colors';

export const APP_NAME = 'bakeEasy';
export const EMAIL_ID = 'EMAIL_ID';
export const DOMAIN = 'DOMAIN';
export const USERNAME = 'USERNAME';
export const DATE_CREATED = [
  'Oldest',
  'Newest',
  'Last 30 days',
  'Last 60 days',
  'Last 90 days',
  'All',
];
export const PRIORITY = ['priority1', 'priority2'];
export const SEND_RECEIVE = ['send1', 'send2'];
export const UNAUTHORIZED = 'Unauthorized, token not available';
export const NO_DATA_FOUND = 'No Data Found';

export const LANGUAGES_ARRAY = [
  { id: 'English', value: 'English' },
  { id: 'French', value: 'Français' },
];

export const LANGUAGES = ['English', 'Français'];

export const STORES = [
  '5<',
  '6-10',
  '11-25',
  '26-50',
  '40-99',
  '100 and above',
];

export const PRODUCTS = [
  '5<',
  '6-10',
  '11-25',
  '26-50',
  '40-99',
  '100 and above',
];

export const ORDERS = [
  '5<',
  '6-10',
  '11-25',
  '26-50',
  '40-99',
  '100 and above',
  'All',
];

export const VALUES = [
  '5<',
  '6-10',
  '11-25',
  '26-50',
  '40-99',
  '100 and above',
  'All',
];

export const STATUS = ['Active', 'Inactive'];

export const LAST_ACCESS = [
  'Oldest',
  'Newest',
  'Last 30 days',
  'Last 60 days',
  'Last 90 days',
  'All',
];

export const ORDERED_DATE = [
  'Oldest',
  'Newest',
  'Last 30 days',
  'Last 60 days',
  'Last 90 days',
  'All',
];

export const DUE_DATE = [
  'Oldest',
  'Newest',
  'Last 30 days',
  'Last 60 days',
  'Last 90 days',
  'All',
];

export const CATEGORY = ['B2B', 'B2C', 'All'];
export const SUBCATEGORY = ['S1', 'S2', 'All'];

export const SUPPLIER = ['One-supplier', 'Multi-Supplier', 'All'];

export const RECIPE_BUILDER = ['YES', 'NO', 'All'];

export const BILL_TO = ['ChainStore', 'Supplier', 'Other'];
export const SHIPPING_CHARGE = ['YES', 'NO'];
export const SHIPPIING_CALCULATION = ['Percentage', 'Amount'];

export const BACKORDER = ['Yes', 'No'];

export const STATUS_ALL_ARRAY1 = ['Active', 'Inactive', 'All'];

export const STATUS_ALL_ARRAY = [
  { id: 'Active', value: 'Active' },
  { id: 'Inactive', value: 'Inactive' },
  { id: 'All', value: 'All' },
];

export const STATES_ARRAY = [
  { id: '1', value: 'State 1' },
  { id: '2', value: 'State 2' },
];

export const CITIES_ARRAY = [
  { id: '1', value: 'City 1' },
  { id: '2', value: 'City 2' },
];

export const STORES_ARRAY = [
  { id: '1', value: 'Store 1' },
  { id: '2', value: 'Store 2' },
];

export const PRODUCTS_ARRAY = [
  { id: '1', value: 'Product 1' },
  { id: '2', value: 'Product 2' },
];

export const STATUS_ARRAY = [
  { id: 'Active', value: 'Active' },
  { id: 'Inactive', value: 'Inactive' },
];

export const ORDERS_ARRAY = [
  { id: '1-100', value: '1-100' },
  { id: '101-500', value: '101-500' },
  { id: '501-1000', value: '501-1000' },
];

export const BILL_TO_ARRAY = [
  { id: 'ChainStore', value: 'ChainStore' },
  { id: 'Store', value: 'Store' },
  { id: 'Other', value: 'Other' },
];

// export const PAYMENT_METHODS_ARRAY = [
//   { id: 'Credit Card', value: 'Credit Card' },
//   { id: 'E-transfer', value: 'E-transfer' },
//   { id: 'PayPal', value: 'PayPal' },
//   { id: 'Cheque', value: 'Cheque' },
//   { id: 'Other', value: 'Other' },
// ];

// export const PAYMENT_TERMS_ARRAY = [
//   { id: 'Monthly', value: 'Monthly' },
//   { id: 'Quarterly', value: 'Quarterly' },
//   { id: 'Annually', value: 'Annually' },
//   { id: 'Other', value: 'Other' },
// ];

export const PAYMENT_METHODS_ARRAY = [
  { id: 'Credit Card', value: 'Credit Card' },
  { id: 'E-transfer', value: 'E-transfer' },
  { id: 'TBA', value: 'TBA' },
  { id: 'Check', value: 'Check' },
  { id: 'Other', value: 'Other' },
  { id: 'Interac', value: 'Interac' },
];

export const PAYMENT_TERMS_ARRAY = [
  { id: 'Net 10 days', value: 'Net 10 days' },
  { id: 'Net 30 days', value: 'Net 30 days' },
  { id: 'Net 60 days', value: 'Net 60 days' },
  { id: 'COD', value: 'COD' },
  { id: 'TBA', value: 'TBA' },
  { id: 'Other', value: 'Other' },
];

export const SETUP_FEE_ARRAY = [
  { id: 'Fee1', value: 'Fee1' },
  { id: 'Fee2', value: 'Fee2' },
];

export const SUBSCRIPTION_PACK_ARRAY = [
  { id: 'Pack1', value: 'Pack1' },
  { id: 'Pack2', value: 'Pack2' },
];

export const TAXES_RATE_1_ARRAY = [
  { id: 'Rate1_1', value: 'Rate1_1' },
  { id: 'Rate1_2', value: 'Rate1_2' },
];

export const TAXES_RATE_2_ARRAY = [
  { id: 'Rate2_1', value: 'Rate2_1' },
  { id: 'Rate2_2', value: 'Rate2_2' },
];

export const SHIP_TO_ARRAY = [
  { id: 'Store', value: 'STORE' },
  { id: 'Pickup', value: 'PICKUP' },
  { id: 'Other', value: 'OTHER' },
];

export const YES_NO_ARRAY = [
  { id: 'Yes', value: 'Yes' },
  { id: 'No', value: 'No' },
];

export const YES_NO_ARRAY_FR = [
  { id: 'Oui', value: 'Oui' },
  { id: 'Non', value: 'Non' },
];

export const SHIPPIING_CALCULATION_ARRAY = [
  { id: 'Percentage', value: 'PERCENTAGE' },
  { id: 'Amount', value: 'AMOUNT' },
];

export const PREFERRED_SHIPPING_METHOD_ARRAY = [
  { id: 'FedEx', value: 'FedEx' },
  { id: 'UPS', value: 'UPS' },
  { id: 'Supplier Delivery', value: 'Supplier Delivery' },
  { id: 'Pickup', value: 'Pickup' },
  { id: 'Other', value: 'Other' },
];

export const PRODUCT_TYPE_ARRAY = [
  { id: 'Manufactured', value: 'Manufactured' },
  { id: 'Purchased', value: 'Purchased' },
];

export const RECIPE_BUILDER_ARRAY = [
  { id: 'Yes', value: 'Yes' },
  { id: 'No', value: 'No' },
];

export const PRIORITY_ARRAY = [
  { id: 'Normal', value: 'NORMAL' },
  { id: 'Urgent', value: 'URGENT' },
];

export const MESSAGE_STATUS_ARRAY = [
  { id: 'Read', value: 'READ' },
  { id: 'Sent', value: 'SENT' },
  { id: 'New', value: 'NEW' },
];

export const PRODUCT_STATUS_ARRAY = [
  { id: 'Active', value: 'ACTIVE' },
  { id: 'Inactive', value: 'INACTIVE' },
  { id: 'Temp. Unavailable', value: 'UNAVAILABLE' },
];

export const FILTERS_ARRAY = [
  'search',
  'page',
  'limit',
  'sortBy',
  'sortDirection',
];

export const ORDER_STATUS_ARRAY = [
  { id: 'New', value: 'NEW' },
  { id: 'Processed', value: 'PROCESSED' },
  { id: 'InProduction', value: 'INPRODUCTION' },
  { id: 'Packed', value: 'PACKED' },
  { id: 'Shipped', value: 'SHIPPED' },
  { id: 'Invoiced', value: 'INVOICED' },
  { id: 'Split', value: 'SPLIT' },
  { id: 'Complete', value: 'COMPLETE' },
  { id: 'Backorder', value: 'BACKORDER' },
  { id: 'Cancelled', value: 'CANCELLED' },
];

export const ORDER_LEGENDS_COLORS = [
  { color: GREEN_100, label: 'NEW' },
  { color: RED_100, label: 'HIGH_PRIORITY' },
  { color: BLUE_GRAY_100, label: 'SPLIT' },
];

export const MESSAGE_LEGENDS_COLORS = [
  { color: GREEN_100, label: 'NEW' },
  { color: RED_100, label: 'URGENT' },
];
